import { FunctionComponent, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

interface RefreshProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}
const Refresh: FunctionComponent<RefreshProps> = ({ size = 16, color = 'black', strokeWidth = 1.5 }) => {
  const [rotation, setRotation] = useState<boolean>(false);
  const onClick = () => {
    setRotation(true);
  };

  return (
    <RefreshSVG
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      rotation={rotation}
      onClick={onClick}
      onAnimationEnd={() => setRotation(false)}
    >
      <path
        d='M11.5753 11.7697C10.8185 12.516 9.85398 13.0244 8.80386 13.2305C7.75373 13.4366 6.66515 13.3313 5.67581 12.9277C4.68648 12.5242 3.84083 11.8406 3.24586 10.9635C2.65089 10.0863 2.33331 9.05498 2.33331 7.99996C2.33331 6.94494 2.65089 5.91362 3.24586 5.03647C3.84083 4.15931 4.68648 3.47573 5.67581 3.07219C6.66515 2.66865 7.75373 2.56328 8.80386 2.76943C9.85398 2.97557 10.8185 3.48395 11.5753 4.23026L13.6666 6.28481M13.6666 6.28481V3.99996M13.6666 6.28481H11.3333'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </RefreshSVG>
  );
};

export default Refresh;

export const RefreshSVG = styled.svg<{ rotation: boolean }>`
  ${({ rotation }) => rotation && rotateAnimation};
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const rotateAnimation = css`
  animation: ${rotate} 0.5s linear;
`;
